let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f4vs2")).then(() => parcelRequire('4lGVX'));